import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { mediaUrl } from "@/lib/api";
import { formatDate } from "@/lib/utils-format";

export default function ArticleCard({ article, size = "md", index = 0 }) {
  if (!article) return null;
  const cat = article.category?.name;
  const catSlug = article.category?.slug;
  const author = article.author?.name;

  const imgH = size === "lg" ? "aspect-[4/3] md:aspect-[16/10]" : size === "tall" ? "aspect-[3/4]" : "aspect-[4/3]";
  const titleSize = size === "lg" ? "text-3xl md:text-4xl" : size === "tall" ? "text-2xl" : "text-xl";

  return (
    <motion.article
      data-testid={`article-card-${article.slug}`}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay: (index % 4) * 0.08 }}
      className="group flex flex-col"
    >
      <Link to={`/articulo/${article.slug}`} className={`img-zoom ${imgH} bg-sunset-border block`}>
        <img src={mediaUrl(article.cover_image)} alt={article.title} loading="lazy"
          className="w-full h-full object-cover" />
      </Link>
      <div className="pt-5">
        {cat && (
          <Link to={`/categoria/${catSlug}`} className="kicker text-sunset-accent hover:opacity-70 transition-opacity">
            {cat}
          </Link>
        )}
        <Link to={`/articulo/${article.slug}`}>
          <h3 className={`font-serif ${titleSize} leading-[1.15] mt-3 mb-3 tracking-tight group-hover:text-sunset-accent transition-colors`}>
            {article.title}
          </h3>
        </Link>
        {size !== "sm" && article.excerpt && (
          <p className="text-sunset-muted text-[15px] leading-relaxed line-clamp-2 mb-4">{article.excerpt}</p>
        )}
        <div className="flex items-center gap-3 text-xs text-sunset-muted">
          {author && <span className="font-medium text-sunset-ink">{author}</span>}
          <span>·</span>
          <span>{formatDate(article.published_at)}</span>
          {article.reading_time && (<><span>·</span><span>{article.reading_time} min</span></>)}
        </div>
      </div>
    </motion.article>
  );
}
